/* eslint-disable no-restricted-globals */
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useSoyuzLocales, useSoyuzClientConfig } from '@spotahome/soyuz/client';

import SoyuzAnalytics from '@spotahome/soyuz-analytics';

import { useCookie } from '../utils/withCookie';

const COOKIE_VALUE = 'google';
const COOKIE_NEW_SOCIAL_USER = 'sah-ui-social';

const COOKIEYES_COOKIE_NAME = 'cookieyes-consent';
const COOKIEYES_NEEDED_COOKIES_PATTERNS = [
  'analytics:yes',
  'advertisement:yes'
];

const sendTracking = notification => {
  if (
    notification.isDismissedMoment() &&
    notification.getDismissedReason() !== 'credential_returned'
  ) {
    const dismissedReason = notification.getDismissedReason();
    SoyuzAnalytics.sendGA4Event('GoogleOneTap', {
      action: 'dismissed',
      reason: dismissedReason
    });
  }
};

const OAUTH_LOGIN_URI = '/marketplace/oauth/sign-in-google';

const GoogleOneTap = () => {
  const { current: currentLocale } = useSoyuzLocales();
  const cookieManager = useCookie();
  const { googleOneTapId } = useSoyuzClientConfig();
  const [scriptCreated, setScriptCreated] = useState(false);

  const handleSuccessCallback = response => {
    const { credential } = response;

    axios
      .post(OAUTH_LOGIN_URI, {
        credential,
        locale: currentLocale
      })
      .then(() => {
        const isNewUser =
          cookieManager.getCookie(COOKIE_NEW_SOCIAL_USER) === '1';
        const newUser = isNewUser ? 'new-user' : 'already-user';
        SoyuzAnalytics.sendGA4Event('GoogleOneTap', {
          action: 'success',
          isNewUser: newUser
        });
        location.reload();
      });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleScriptLoad = () => {
    if (window.google.accounts) {
      window.google.accounts.id.initialize({
        client_id: googleOneTapId,
        callback: handleSuccessCallback,
        cancel_on_tap_outside: false,
        use_fedcm_for_prompt: true,
        context: 'use'
      });
      window.google.accounts.id.prompt(sendTracking);
    }
  };

  const createScript = () => {
    if (scriptCreated) {
      return;
    }

    const isGoogleCookieSet =
      cookieManager.getCookie('authMethod') === COOKIE_VALUE ||
      !cookieManager.getCookie('authMethod');

    const cookieYesCookies = cookieManager.getCookie(COOKIEYES_COOKIE_NAME);
    const isCookieYesCookiesAccepted = COOKIEYES_NEEDED_COOKIES_PATTERNS.every(
      pattern => cookieYesCookies?.includes(pattern)
    );

    const mustCreateScript = isGoogleCookieSet && isCookieYesCookiesAccepted;

    if (mustCreateScript) {
      setScriptCreated(true);

      const script = document.createElement('script');
      script.defer = true;
      script.src = 'https://accounts.google.com/gsi/client';
      script.onload = handleScriptLoad;

      document.body.appendChild(script);
    }
  };

  useEffect(() => {
    createScript();

    const handleCookieChanged = event => {
      const cookieYesChanged = event.changed.some(
        cookie => cookie.name === COOKIEYES_COOKIE_NAME
      );

      if (cookieYesChanged) {
        createScript();
      }
    };

    if (window.cookieStore) {
      window.cookieStore.addEventListener('change', handleCookieChanged);
    }

    return () => {
      if (window.cookieStore) {
        window.cookieStore.removeEventListener('change', handleCookieChanged);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default GoogleOneTap;
